import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CreatorAuthGuard, SuperAdminAuthGuard } from '@motes-sdk';

const routes: Routes = [
    { path: '', pathMatch: 'full', canActivate: [CreatorAuthGuard] },
    { path: 'dashboard', loadChildren: () => import('./pages/dashboard-page/dashboard-page.module').then(m => m.DashboardPageModule), canActivate: [CreatorAuthGuard] },
    { path: 'login', loadComponent: () => import('./pages/login-page/login-page.component').then(m => m.LoginPageComponent) },
    { path: 'editor', loadChildren: () => import('./pages/editor-page/editor-page.module').then(m => m.EditorPageModule), data: { showEditorMenu: true }, canActivate: [CreatorAuthGuard] },
    { path: 'profile', loadComponent: () => import('./pages/profile-page/profile-page.component').then(m => m.ProfilePageComponent), canActivate: [CreatorAuthGuard] },
    { path: 'subscription/:projectKey', loadComponent: () => import('./pages/subscription-page/subscription-page.component').then(m => m.SubscriptionPageComponent), canActivate: [CreatorAuthGuard] },
    { path: 'create-tour/:projectKey', loadComponent: () => import('./pages/create-tour-page/create-tour-page.component').then(m => m.CreateTourPageComponent), canActivate: [CreatorAuthGuard] },
    { path: 'create-tour/:projectKey/:tourType', loadComponent: () => import('./pages/create-tour-page/create-tour-page.component').then(m => m.CreateTourPageComponent), canActivate: [CreatorAuthGuard] },
    { path: 'create-world', loadComponent: () => import('./pages/create-world-page/create-world-page.component').then(m => m.CreateWorldPageComponent), canActivate: [CreatorAuthGuard] },
    { path: 'admin', loadChildren: () => import('./pages/admin-page/admin-page.module').then(m => m.AdminPageModule), canActivate: [SuperAdminAuthGuard] },
    { path: '404', loadComponent: () => import('./pages/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent) },
    { path: '**', loadComponent: () => import('./pages/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent) },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            initialNavigation: 'enabledBlocking',
            scrollPositionRestoration: 'enabled'
        })
    ],
    exports: [RouterModule]
})

export class AppRoutingModule { }
